import React, { Suspense } from 'react';
const StoreComponent = React.lazy(() => import('../Component/StoreComponent/StoreComponent'));

function StorePage(props) {
  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <StoreComponent />
      </Suspense>
    </>
  );
}

export default StorePage;
